import Cities from "./cities.json";
import Regions from "./states.json";
import Countries from "./countries.json";
import RegionDB from "./countries_states_cities.json";

export const searchTypes = [
  {
    label: "City",
    id: "cityLevel",
  },
  {
    label: "State / Region",
    id: "stateLevel",
  },
  {
    label: "Country",
    id: "countryLevel",
  },
];

export const GetCities = (search_input = "", regionType) => {
  const api_types = {
    cityLevel: Cities,
    stateLevel: Regions,
    countryLevel: Countries,
  };

  const list = api_types[regionType] || [];
  const query = search_input.toLowerCase();

  const getName = (el) => {
    switch (regionType) {
      case "countryLevel":
        return el?.name?.toLowerCase() || "";

      case "stateLevel":
        return `${el?.name || ""}, ${el?.country?.name || ""}`.toLowerCase();

      default:
        return `${el?.name || ""}, ${el?.state?.name || ""}, ${el?.country?.name || ""}`.toLowerCase();
    }
  };

  return list
    .filter((el) => getName(el).startsWith(query))
    .slice(0, 20);
};

// export const DownloadCities = () => {
//   let newList = [];
//   for (let Country of RegionDB) {
//     for (let State of Country["states"]) {
//       let cityObj = {
//         name: State?.name,
//         iso2: State?.iso2,
//         iso3: State?.iso3166_2,
//         id: State?.id,
//         country: {
//           name: Country?.name,
//           iso3: Country?.iso3,
//           iso2: Country?.iso2,
//           id: Country?.id,
//         },
//       };
//       newList.push(cityObj);
//
//     }
//   }
//
//   const jason = JSON.stringify(newList);
//   const blob = new Blob([jason], { type: "application/json" });
//   const url = URL.createObjectURL(blob);
//
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = "states.json";
//
//   document.body.appendChild(link);
//   link.click();
//
//   link.remove();
//   URL.revokeObjectURL(url);
// };

